<template>
  <div>
    <v-container fluid>
      <v-card v-show="!loading">
        <v-app-bar color="primary" flat dark dense>
          <v-toolbar-title>
            Informações da Rodada
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn
            depressed
            color="primary lighten-4"
            @click="$router.push('/rodadas')"
            >Voltar</v-btn
          >
        </v-app-bar>
        <v-form ref="form">
          <v-container fluid class="pb-0" style="pointer-events: none">
            <v-row dense>
              <v-col sm="9">
                <v-text-field
                  label="Nome"
                  ref="nome"
                  v-model="rodada.nome"
                  readonly
                ></v-text-field>
              </v-col>
              <v-col sm="3" cols="6">
                <as-date-picker-menu
                  label="Data Início"
                  ref="data_inicio"
                  v-model="rodada.data_inicio"
                  readonly
                ></as-date-picker-menu>
              </v-col>
              <v-col sm="9">
                <v-text-field
                  label="Local"
                  ref="local"
                  v-model="rodada.local"
                  readonly
                ></v-text-field>
              </v-col>
              <v-col sm="3" cols="6">
                <as-date-picker-menu
                  label="Data Fim"
                  ref="data_fim"
                  v-model="rodada.data_fim"
                  readonly
                ></as-date-picker-menu>
              </v-col>
            </v-row>
            <v-row dense>
              <v-col sm="3" cols="6">
                <as-date-picker-menu
                  label="Data Veiculação"
                  ref="data_veiculacao"
                  readonly
                  v-model="rodada.data_veiculacao"
                ></as-date-picker-menu>
              </v-col>
              <v-col sm="3" cols="6">
                <as-date-picker-menu
                  label="Data Limite"
                  ref="data_limite"
                  readonly
                  v-model="rodada.data_limite"
                ></as-date-picker-menu>
              </v-col>
              <v-col sm="3" cols="6">
                <v-text-field
                  label="Estado"
                  ref="estado"
                  v-model="rodada.estado_nome"
                  readonly
                ></v-text-field>
              </v-col>
              <v-col sm="3" cols="6">
                <v-text-field
                  label="Cidade"
                  ref="cidade"
                  v-model="rodada.cidade_nome"
                  readonly
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-card>

      <v-card v-show="!loading" class="mt-3">
        <v-app-bar color="primary" flat dark dense>
          <v-toolbar-title>Clientes</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn
            depressed
            small
            fab
            color="primary lighten-4"
            @click="$refs.dialogoImprimirClientesEtiqueta.abrir()"
            class="mr-2"
            v-if="user.tipo == 'administrador' || user.tipo == 'representante'"
          >
            <v-icon>badge</v-icon>
          </v-btn>
          <v-btn
            depressed
            small
            fab
            color="primary lighten-4"
            @click="$refs.dialogoImprimirClientes.abrir()"
            class="mr-2"
            v-if="user.tipo == 'administrador'"
          >
            <v-icon>print</v-icon>
          </v-btn>
          <v-btn
            depressed
            small
            fab
            color="primary lighten-4"
            @click="tooglePesquisa"
          >
            <v-icon>search</v-icon>
          </v-btn>
          <v-btn
            depressed
            color="primary lighten-4"
            class="ml-2"
            @click="abriDialogoClientes"
            v-if="user.tipo == 'administrador' && podeEditar(rodada.data_fim)"
            >Adicionar</v-btn
          >
        </v-app-bar>

        <v-expand-transition>
          <v-row dense v-show="exibirPesquisa" class="pa-2">
            <v-col>
              <v-text-field
                ref="pesquisa"
                label="Pesquisa"
                v-model="pesquisa"
                prepend-inner-icon="search"
                solo
                background-color="grey lighten-2"
                clearable
                single-line
                hide-details
                placeholder="Pesquisa"
                color="primary"
                @click:clear="tooglePesquisa"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-expand-transition>

        <v-divider />

        <v-data-table
          :search="pesquisa"
          :headers="headers"
          :items="clientes_rodada"
          :loading="loading"
          :items-per-page="30"
          :footer-props="{
            itemsPerPageOptions: [10, 30, 50, { text: 'Todos', value: -1 }],
            itemsPerPageText: 'Registros Exibidos',
          }"
          no-data-text="Sem registros"
          no-results-text="Sem registros"
          loading-text="Carregando dados..."
        >
          <template
            v-slot:item.acoes="{ item }"
            v-if="user.tipo == 'administrador' && podeEditar(rodada.data_fim)"
          >
            <td>
              <v-btn icon text @click="abrirdialogoExcluir(item)">
                <v-icon>close</v-icon>
              </v-btn>
            </td>
          </template>
        </v-data-table>
      </v-card>

      <v-row v-show="loading" class="justify-center align-center mt-5">
        <v-progress-circular
          indeterminate
          size="50"
          width="3"
          color="primary"
        ></v-progress-circular>
      </v-row>
    </v-container>

    <as-dialogo
      ref="dialogoClientes"
      title="Seleção de Clientes"
      max-width="1200px"
      altura="525px"
    >
      <v-row dense v-show="!loading_adicionar">
        <v-col pa-2>
          <v-text-field
            ref="pesquisa2"
            label="Pesquisa"
            v-model="pesquisa2"
            prepend-inner-icon="search"
            solo
            background-color="grey lighten-2"
            clearable
            single-line
            hide-details
            placeholder="Pesquisa"
            color="primary"
            @click:clear="tooglePesquisa"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row dense v-show="!loading_adicionar">
        <v-col pa-2>
          <v-card>
            <v-data-table
              :search="pesquisa2"
              :headers="headers"
              :items="clientes"
              hide-default-footer
              :loading="loading"
              :items-per-page="30"
              :footer-props="{
                itemsPerPageOptions: [10, 30, 50, { text: 'Todos', value: -1 }],
                itemsPerPageText: 'Registros Exibidos',
              }"
              no-data-text="Sem registros"
              no-results-text="Sem registros"
              loading-text="Carregando dados..."
            >
              <template v-slot:item.acoes="{ item }">
                <td>
                  <v-btn
                    text
                    icon
                    @click="adicionarCliente(item)"
                    :loading="item.adicionando"
                    :disabled="item.adicionando"
                  >
                    <v-icon>add</v-icon>
                  </v-btn>
                </td>
              </template>
            </v-data-table>
          </v-card>
        </v-col>
      </v-row>
      <v-row v-show="loading_adicionar" class="justify-center align-center">
        <v-progress-circular
          indeterminate
          size="50"
          width="3"
          color="primary"
        ></v-progress-circular>
      </v-row>
    </as-dialogo>

    <as-dialogo
      ref="dialogoImprimirClientes"
      title="Imprimir Lista de Clientes"
      max-width="728px"
      hideCloseButton
    >
      <v-label
        >Tem certeza que deseja imprimir a lista de clientes dessa
        rodada?</v-label
      >
      <div class="pt-8" style="display: flex; justify-content: flex-end;">
        <v-btn
          depressed
          class="mr-4"
          @click="$refs.dialogoImprimirClientes.fechar()"
          >Cancelar</v-btn
        >
        <v-btn
          depressed
          color="primary"
          @click="imprimirListaClientes"
          :loading="loading_imprimir"
          :disabled="loading_imprimir"
          >Imprimir</v-btn
        >
      </div>
    </as-dialogo>

    <as-dialogo
      ref="dialogoImprimirClientesEtiqueta"
      title="Imprimir Etiquetas de Clientes"
      max-width="728px"
      hideCloseButton
    >
      <v-label
        >Tem certeza que deseja imprimir as etiquetas de clientes dessa
        rodada?</v-label
      >
      <div class="pt-8" style="display: flex; justify-content: flex-end;">
        <v-btn
          depressed
          class="mr-4"
          @click="$refs.dialogoImprimirClientesEtiqueta.fechar()"
          >Cancelar</v-btn
        >
        <v-btn
          depressed
          color="primary"
          @click="imprimirEtiquetasClientes"
          :loading="loading_imprimir"
          :disabled="loading_imprimir"
          >Imprimir</v-btn
        >
      </div>
    </as-dialogo>

    <as-dialogo
      ref="dialogoExcluir"
      title="Exclusão de Cliente"
      max-width="728px"
      hideCloseButton
    >
      <v-label
        >Tem certeza que deseja remover esse cliente dessa rodada?</v-label
      >
      <div class="pt-8" style="display: flex; justify-content: flex-end;">
        <v-btn depressed class="mr-4" @click="$refs.dialogoExcluir.fechar()"
          >Cancelar</v-btn
        >
        <v-btn
          depressed
          color="error"
          @click="excluirCliente"
          :loading="loading_excluir"
          :disabled="loading_excluir"
          >Excluir</v-btn
        >
      </div>
    </as-dialogo>
  </div>
</template>

<script>
import ServiceRodadas from "../../services/rodadas.js";
import ServiceImpressoes from "../../services/impressoes";

export default {
  name: "ClientesSelecao",
  data() {
    return {
      user: {},
      loading: false,
      loading_adicionar: false,
      loading_excluir: false,
      exibirPesquisa: false,
      adicionando: false,
      pesquisa: "",
      pesquisa2: "",
      rodada: {
        nome: "",
        local: "",
        data_inicio: "",
        data_fim: "",
        data_veiculacao: "",
        estado_nome: "",
        cidade_nome: "",
      },
      clientes_rodada: [],
      headers: [],
      clientes: [],
      cliente: {},
      loading_imprimir: false,
    };
  },
  mounted() {
    this.user = JSON.parse(localStorage.getItem("user"));
    this.abrir();
    if (this.user.tipo == "administrador") {
      this.headers = [
        { text: "Responsável", value: "responsavel_nome", width: "35%" },
        { text: "Empresa", value: "nome", width: "35%" },
        { text: "Representante", value: "representante_nome", width: "25%" },
        {
          text: "",
          value: "acoes",
          sortable: false,
          width: "5%",
          align: "center",
        },
      ];
    } else {
      this.headers = [
        { text: "Empresa", value: "nome", width: "35%" },
        { text: "Responsável", value: "responsavel_nome", width: "35%" },
        { text: "Representante", value: "representante_nome", width: "25%" },
        {
          text: "",
          value: "acoes",
          sortable: false,
          width: "5%",
          align: "center",
        },
      ];
    }
  },
  methods: {
    podeEditar(dataFim) {
      return new Date(dataFim) > new Date();
    },
    tooglePesquisa() {
      this.exibirPesquisa = !this.exibirPesquisa;
      if (this.exibirPesquisa) {
        setTimeout(() => {
          this.$refs.pesquisa.focus();
        }, 0);
      }
    },
    async abrir() {
      try {
        this.loading = true;
        let response_rodada = await ServiceRodadas.abrir(
          this.$route.params.rodada_id
        );
        this.rodada = response_rodada.data.rodada;

        let response_clientes_rodada = await ServiceRodadas.carregarClientesRodada(
          this.$route.params.rodada_id
        );
        this.clientes_rodada = response_clientes_rodada.data.clientes;
      } catch (error) {
        console.log(error);
        this.$eventbus.erro("Erro ao buscar rodada", error);
      } finally {
        this.loading = false;
      }
    },
    async abriDialogoClientes() {
      this.$refs.dialogoClientes.abrir();
      try {
        this.loading_adicionar = true;
        this.pesquisa2 = "";
        let clientes_lista = await ServiceRodadas.carregarClientes(
          this.$route.params.rodada_id
        );
        this.clientes = clientes_lista.data.clientes;
        setTimeout(() => {
          this.$refs.pesquisa2.focus();
        }, 0);
      } catch (error) {
        console.log(error);
        this.$eventbus.erro("Erro ao carregar clientes", error);
      } finally {
        this.loading_adicionar = false;
      }
    },
    async adicionarCliente(cliente) {
      try {
        this.$set(cliente, "adicionando", true);
        await ServiceRodadas.salvarCliente(
          this.$route.params.rodada_id,
          cliente.id
        );
        this.$eventbus.notificar(
          cliente.responsavel_nome +
            " (" +
            cliente.nome +
            ") adicionado a rodada com sucesso"
        );

        let response_cliente_rodada = await ServiceRodadas.carregarClientesRodada(
          this.$route.params.rodada_id
        );
        this.clientes_rodada = response_cliente_rodada.data.clientes;
      } catch (error) {
        console.log(error);
        this.$eventbus.erro("Erro ao salvar o cliente", error);
      } finally {
        this.$set(cliente, "adicionando", false);

        let clientes_lista = await ServiceRodadas.carregarClientes(
          this.$route.params.rodada_id
        );
        this.clientes = clientes_lista.data.clientes;
      }
    },
    abrirdialogoExcluir(cliente) {
      this.cliente = cliente;
      this.$refs.dialogoExcluir.abrir();
    },
    async excluirCliente() {
      try {
        this.loading_excluir = true;

        await ServiceRodadas.excluirCliente(
          this.$route.params.rodada_id,
          this.cliente.id
        );
        this.$eventbus.notificar(
          this.cliente.responsavel_nome +
            " (" +
            this.cliente.nome +
            ") removido da rodada com sucesso"
        );
      } catch (error) {
        console.log(error);
        this.$eventbus.erro("Erro ao excluir o cliente", error);
      } finally {
        let response_clientes_rodada = await ServiceRodadas.carregarClientesRodada(
          this.$route.params.rodada_id
        );
        this.clientes_rodada = response_clientes_rodada.data.clientes;

        this.loading_excluir = false;
        this.$refs.dialogoExcluir.fechar();
        this.cliente = {};
      }
    },
    async importarClientes() {
      try {
        let response = await ServiceRodadas.importarClientes(
          this.$route.params.rodada_id
        );
        this.$eventbus.notificar("Clientes importados com sucesso");
      } catch (error) {
        console.log(error);
        this.$eventbus.erro("Erro ao importar clientes");
      }
    },
    async imprimirListaClientes() {
      try {
        this.loading_imprimir = true;
        let impressao = JSON.parse(localStorage.getItem("impressao_remota"))
          ? "remota"
          : "local";
        if (impressao == "local") {
          this.$store.commit("showImprimirPdf", true);
        }
        let pdf = await ServiceImpressoes.imprimirListaClientesRodada({
          impressao: impressao,
          rodada_id: this.rodada.id,
        });
        if (impressao == "local") {
          this.$store.commit("setPdfUrl", pdf);
        } else {
          this.$eventbus.notificar(
            "Impressão encaminhada para a Ilha de Impressão com sucesso"
          );
        }
      } catch (error) {
        console.log(error);
        this.$eventbus.erro("Erro ao imprimir listagem de clientes da rodada");
      } finally {
        this.loading_imprimir = false;
        this.$refs.dialogoImprimirClientes.fechar();
      }
    },
    async imprimirEtiquetasClientes() {
      try {
        this.loading_imprimir = true;
        let impressao = JSON.parse(localStorage.getItem("impressao_remota"))
          ? "remota"
          : "local";
        if (impressao == "local") {
          this.$store.commit("showImprimirPdf", true);
        }
        let pdf = await ServiceImpressoes.imprimirEtiquetasClientesRodada({
          impressao: impressao,
          rodada_id: this.rodada.id,
        });
        if (impressao == "local") {
          this.$store.commit("setPdfUrl", pdf);
        } else {
          this.$eventbus.notificar(
            "Impressão encaminhada para a Ilha de Impressão com sucesso"
          );
        }
      } catch (error) {
        this.$eventbus.erro(
          "Erro ao imprimir as etiquetas de clientes da rodada"
        );
      } finally {
        this.loading_imprimir = false;
        this.$refs.dialogoImprimirClientesEtiqueta.fechar();
      }
    },
  },
};
</script>

<style></style>
